import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import FundingLenderDetail from '../../components/funding/FundingLenderDetail';
import FundingPanel from '../../components/funding/FundingPanel';
import FundingSectionPage from '../../components/funding/FundingSectionPage';
import { useFundingWorkspace } from '../../context/FundingWorkspaceContext';
import { useFundingLenderDetail } from '../../hooks/funding/useFundingLenders';
import { useFundingRoutes } from '../../hooks/funding/useFundingRoutes';

const FundingLenderDetailPage = () => {
  const { lenderId } = useParams();
  const navigate = useNavigate();
  const { lenders: lendersPath } = useFundingRoutes();
  const { workspaceAgencyId, isPlatformContext } = useFundingWorkspace();
  const agencyId = isPlatformContext ? workspaceAgencyId || undefined : workspaceAgencyId;

  const {
    detail,
    loading,
    saving,
    error,
    update,
    archive,
    addProduct,
    removeProduct,
  } = useFundingLenderDetail({ lenderId, agencyId, autoLoad: true });

  const handleArchive = async () => {
    await archive();
    navigate(lendersPath);
  };

  return (
    <FundingSectionPage
      title="Lender detail"
      subtitle="Criteria, products, and historical performance."
      activeStage="match"
      actions={(
        <Link to={lendersPath} className="text-sm font-medium text-[var(--fg-accent)] hover:underline">
          Back to lenders
        </Link>
      )}
    >
      {error ? (
        <div className="mb-4 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700 dark:border-rose-900/40 dark:bg-rose-950/30 dark:text-rose-200">
          {error}
        </div>
      ) : null}

      <FundingPanel>
        <FundingLenderDetail
          detail={detail}
          loading={loading}
          saving={saving}
          canEdit={isPlatformContext}
          onUpdate={update}
          onArchive={handleArchive}
          onAddProduct={addProduct}
          onDeleteProduct={removeProduct}
        />
      </FundingPanel>
    </FundingSectionPage>
  );
};

export default FundingLenderDetailPage;
